// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3gTfk","list":"BalanceDue_list__1QSiB","listRow":"BalanceDue_listRow__3__qt","total":"BalanceDue_total__2SzR7"};